<template>
    <div class="page home">
        <div class="inner page__inner home__inner">
            <div class="page__content home__content">
                <div class="home__title">
                    Камни и талисманы<br />
                    по методу Шахрай
                </div>
                <div class="home__text">
                  Метод Шахрай, являющийся первым и единственным в мире подходом своего рода, официально запатентован
                  и признан на государственном уровне как интеллектуальная собственность. Эта инновационная система
                  разработана специально для выявления персональных талисманов каждого индивида, предоставляя уникальные ключи к позитивным изменениям в жизни через определение личных символов удачи и силы.
                  <br /><br>
                  В основе метода лежит аналитика уникальных цифровых последовательностей, ассоциируемых с личностными данными человека, что позволяет изучать статистические связи между этими последовательностями и различными аспектами жизни человека, включая психологические характеристики, поведенческие модели и ключевые жизненные события. Применяя методы математической статистики, метод Шахрай систематически анализирует данные, выявляя потенциальные закономерности, которые помогают в определении индивидуальных талисманов, усиливающих личную силу и способствующих достижению гармонии в жизни.
                  <br><br>
                  Таким образом, Вы точно будете знать какие камни подходят именно Вам: <br>
                  • как талисманы и обереги;
                  <br><br>
                  Какие камни станут для Вас: <br>
                  • персональными помощниками;<br>
                  • защитниками;<br>
                  • хранителями энергии;
                  <br><br>
                  Какие камни притягивают: <br>
                  • финансовые потоки;<br>
                  • положительные события;<br>
                  • энергии любви <br>
                  и приводят Вас к желаемому результату.
                </div>
                
                <!-- табы для форм -->
                <div class="home__tabs test" v-if="isAuthenticated">
                    <button 
                        type="button"
                        class="home__tab"
                        :class="{ 'home__tab--active': activeTab === 'ru' }"
                        @click="activeTab = 'ru'"
                    >
                        RU
                    </button>
                    <button 
                        type="button"
                        class="home__tab"
                        :class="{ 'home__tab--active': activeTab === 'eng' }"
                        @click="activeTab = 'eng'"
                    >
                        ENG
                    </button>
                </div>
                
                <!-- ru форма -->
                <form v-if="activeTab === 'ru' && isAuthenticated" @submit.prevent="submitAnalyze" class="home__form">
                    <div class="home__form-content">

                        <Field class="home__form-field">
                            <template #label>Фамилия <span>(при рождении)</span></template>
                            <template #content>
                                <InputText v-model="form.lastName" placeholder="Иванов" />
                            </template>
                            <template v-if="$v.form.lastName.$error" #error>{{
                                $v.form.lastName.$dirty ? getError($v.form.lastName) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Имя <span>(при рождении)</span></template>
                            <template #content>
                                <InputText v-model="form.firstName" placeholder="Иван" />
                            </template>
                            <template v-if="$v.form.firstName.$error" #error>{{
                                $v.form.firstName.$dirty ? getError($v.form.firstName) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Отчество <span>(при рождении)</span></template>
                            <template #content>
                                <InputText v-model="form.middleName" placeholder="Иванович" />
                            </template>
                            <template v-if="$v.form.middleName.$error" #error>{{
                                $v.form.middleName.$dirty ? getError($v.form.middleName) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Дата рождения</template>
                            <template #content>
                                <datepicker
                                    v-model="form.birthdate"
                                    placeholder="01.01.1992"
                                    format="dd.MM.yyyy"
                                    :minimumView="'day'"
                                    :maximumView="'year'"
                                    :initialView="'year'"
                                    :language="ru"
                                ></datepicker>
                            </template>
                            <template v-if="$v.form.birthdate.$error" #error>{{
                                $v.form.birthdate.$dirty ? getError($v.form.birthdate) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Email</template>
                            <template #content>
                                <InputText
                                    v-model="form.email"
                                    type="email"
                                    placeholder="email@mail.ru"
                                />
                            </template>
                            <template v-if="$v.form.email.$error" #error>{{
                                $v.form.email.$dirty ? getError($v.form.email) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Телефон</template>
                            <template #content>
                                <InputText
                                    v-model="form.phone"
                                    mask="+7 (###) ###-##-##"
                                    type="tel"
                                    placeholder="+7 (999) 444 55-55"
                                />
                            </template>
                        </Field>
                    </div>

                    <Button submit class="home__form-button">Произвести расчет</Button>
                </form>

                <!-- eng форма -->
                <form v-if="activeTab === 'eng' && isAuthenticated" @submit.prevent="submitAnalyze" class="home__form">
                    <div class="home__form-content">

                        <Field class="home__form-field">
                            <template #label>Last Name <span>(at birth)</span></template>
                            <template #content>
                                <InputText v-model="form.lastName" placeholder="Smith" />
                            </template>
                            <template v-if="$v.form.lastName.$error" #error>{{
                                $v.form.lastName.$dirty ? getError($v.form.lastName) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>First Name <span>(at birth)</span></template>
                            <template #content>
                                <InputText v-model="form.firstName" placeholder="John" />
                            </template>
                            <template v-if="$v.form.firstName.$error" #error>{{
                                $v.form.firstName.$dirty ? getError($v.form.firstName) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>
                                Patronymic <span>(at birth)</span>
                                <span class="field__tooltip-icon">
                                    !
                                    <span class="field__tooltip-text">
                                        Note: "Patronymic" is specific to some cultures; in English forms, this might be a "Middle Name".
                                    </span>
                                </span>
                            </template>
                            <template #content>
                                <InputText v-model="form.middleName" placeholder="Michael" />
                            </template>
                            <template v-if="$v.form.middleName.$error" #error>{{
                                $v.form.middleName.$dirty ? getError($v.form.middleName) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Date of Birth</template>
                            <template #content>
                                <datepicker
                                    v-model="form.birthdate"
                                    placeholder="01/01/1992"
                                    format="dd.MM.yyyy"
                                    :minimumView="'day'"
                                    :maximumView="'year'"
                                    :initialView="'year'"
                                    :language="ru"
                                ></datepicker>
                            </template>
                            <template v-if="$v.form.birthdate.$error" #error>{{
                                $v.form.birthdate.$dirty ? getError($v.form.birthdate) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Email</template>
                            <template #content>
                                <InputText
                                    v-model="form.email"
                                    type="email"
                                    placeholder="john.smith@example.com"
                                />
                            </template>
                            <template v-if="$v.form.email.$error" #error>{{
                                $v.form.email.$dirty ? getError($v.form.email) : ''
                            }}</template>
                        </Field>

                        <Field class="home__form-field">
                            <template #label>Phone Number</template>
                            <template #content>
                                <InputText
                                    v-model="form.phone"
                                    mask="+1 (###) ###-####"
                                    type="tel"
                                    placeholder="+1 (555) 123-4567"
                                />
                            </template>
                        </Field>
                    </div>

                    <Button submit class="home__form-button">Calculate</Button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import 'moment/locale/ru';
import { required } from 'vuelidate/lib/validators';

import Field from '../../components/field/field';
import InputText from '../../components/input-text/input-text';
import Button from '../../components/button/button';

import alphabets from '../../_data/alphabets.json';

export default {
    data: () => ({
        ru,
        alphabets,
        pending: false,
        activeTab: 'ru',
        form: {
            firstName: null,
            middleName: null,
            lastName: null,
            birthdate: null,
            alphabet: alphabets[0].id,
            email: null,
            phone: null,
        },
    }),
    components: {
        Datepicker,
        Field,
        InputText,
        Button,
    },
    computed: {
        ...mapState({
            profileInfo: (state) => state.profileInfo,
            profileAnalyzes: (state) => state.profileAnalyzes,
        }),
        ...mapGetters(['isAuthenticated']),
    },
    validations: {
        form: {
            firstName: {
                required,
            },
            middleName: {
                required,
            },
            lastName: {
                required,
            },
            birthdate: {
                required,
            },
            email: {
                required,
            },
        },
    },
    methods: {
        async preloadUserData() {
            if (!this.isAuthenticated) {
                return;
            }

            await Promise.all([
                this.$store.dispatch('getProfileInfo'),
                this.$store.dispatch('getProfileAnalyzes'),
            ]);

            this.fillFormFromUserData();
        },
        fillFormFromUserData() {
            const lastAnalyze = Array.isArray(this.profileAnalyzes) ? this.profileAnalyzes[0] : null;

            this.form = {
                ...this.form,
                firstName: lastAnalyze?.firstName || this.form.firstName,
                middleName: lastAnalyze?.middleName || this.form.middleName,
                lastName: lastAnalyze?.lastName || this.form.lastName,
                birthdate: this.parseBirthdate(lastAnalyze?.birthdate) || this.form.birthdate,
                email: this.profileInfo?.email || this.form.email,
                phone: this.profileInfo?.phone || this.form.phone,
            };
        },
        parseBirthdate(birthdate) {
            if (!birthdate) {
                return null;
            }

            const parsedBirthdate = moment(birthdate, 'DD.MM.YYYY', true);

            return parsedBirthdate.isValid() ? parsedBirthdate.toDate() : null;
        },
        getError(validation) {
            // Возвращаем текст ошибки в зависимости от языка
            if (this.activeTab === 'ru') {
                return 'Обязательное поле';
            } else {
                return 'Required field';
            }
        },
        
        submitAnalyze() {
            this.$v.$touch();

            if (!this.$v.$invalid && !this.pending) {
                this.pending = true;

                this.$store
                    .dispatch('getAnalyze', {
                        firstName: this.form.firstName,
                        middleName: this.form.middleName,
                        lastName: this.form.lastName,
                        birthdate: moment(this.form.birthdate).format('L'),
                        alphabet: this.form.alphabet,
                        email: this.form.email,
                        phone: this.form.phone,
                    })
                    .then((response) => {
                        this.pending = false;
                        this.$store.commit('setAnalyze', response.data);
                        this.$router.push('/analyze');
                        
                        if (this.isAuthenticated) {
                            this.$store.dispatch('getProfileAnalyzes');
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.pending = false;
                    });
            }
        },
    },
    created() {
        this.preloadUserData();
    },
};
</script>

<style src="./home.less" lang="less"></style>
